export var PhoneNumberFormatter = (function() {
/* Get the format in which the phone number should be displayed on the page. */
    var getPhoneDisplayFormat = function(countryCode, phoneNumber) {
        if (!phoneNumber) {
            return;
        }
        phoneNumber = phoneNumber.replace(/\D/g, '');

        // countryCode represents the code selected for the phone number.
        // It may not be the same as the market.
        switch (countryCode) {
        case 'US':
            phoneNumber = phoneNumber.substr(0, 10);
            return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        case 'CA':
            phoneNumber = phoneNumber.substr(0, 10);
            return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        case 'AU':
            phoneNumber = phoneNumber.substr(0, 10);
            if (phoneNumber.length == 10) {
                return phoneNumber.replace(/(\d{2})(\d{4})(\d{4})/, '$1 $2 $3');
            } else if (phoneNumber.length == 9) {
                return phoneNumber.replace(/(\d{2})(\d{4})(\d{3})/, '$1 $2 $3');
            } else {
                return phoneNumber;
            }
        case 'NZ':
            phoneNumber = phoneNumber.substr(0, 10);
            if (phoneNumber.length == 10) {
                return phoneNumber.replace(/(\d{2})(\d{4})(\d{4})/, '$1 $2 $3');
            } else if (phoneNumber.length == 9) {
                return phoneNumber.replace(/(\d{2})(\d{4})(\d{3})/, '$1 $2 $3');
            } else {
                return phoneNumber;
            }
        case 'ES':
            phoneNumber = phoneNumber.substr(0, 9);
            return phoneNumber.replace(/(\d{3})(\d{6})/, '($1) $2');
        case 'FR':
            phoneNumber = phoneNumber.substr(0, 11);
            if (phoneNumber.length === 10) {
                return phoneNumber.replace(/(\d{10})/, '0$1');
            }
            return phoneNumber;
        case 'GB':
            phoneNumber = phoneNumber.substr(0, 11);
            if (phoneNumber.length === 10) {
                return phoneNumber.replace(/(\d{10})/, '0$1');
            }
            return phoneNumber;
        case 'NO':
            phoneNumber = phoneNumber.substr(0, 11);
            if (phoneNumber.length === 10) {
                return phoneNumber.replace(/(\d{10})/, '0$1');
            }
            return phoneNumber;
        case 'DE':
            phoneNumber = phoneNumber.substr(0, 11);
            if (phoneNumber.length === 10) {
                return phoneNumber.replace(/(\d{10})/, '0$1');
            }
            return phoneNumber;
        case 'BE':
            phoneNumber = phoneNumber.substr(0, 10);
            return phoneNumber.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
        case 'AT':
            phoneNumber = phoneNumber.substr(0, 10);
            return phoneNumber.replace(/(\d{4})(\d{6})/, '$1-$2');
        case 'CZ':
            phoneNumber = phoneNumber.substr(0, 9);
            return phoneNumber.replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3');
        case 'DK':
            phoneNumber = phoneNumber.substr(0, 8);
            return phoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4');
        case 'HU':
            phoneNumber = phoneNumber.substr(0, 9);
            return phoneNumber.replace(/(\d{2})(\d{3})(\d{4})/, '($1) $2-$3');
        case 'IS':
            phoneNumber = phoneNumber.substr(0, 7);
            return phoneNumber.replace(/(\d{3})(\d{4})/, '$1 $2');
        case 'IL':
            phoneNumber = phoneNumber.substr(0, 10);
            return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
        case 'IT':
            phoneNumber = phoneNumber.substr(0, 10);
            return phoneNumber.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
        case 'LU':
            phoneNumber = phoneNumber.substr(0, 9);
            return phoneNumber.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
        case 'PT':
            phoneNumber = phoneNumber.substr(0, 9);
            return phoneNumber.replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3');
        case 'RO':
            phoneNumber = phoneNumber.substr(0, 9);
            return phoneNumber.replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3');
        case 'RU':
            phoneNumber = phoneNumber.substr(0, 7);
            return phoneNumber.replace(/(\d{3})(\d{2})(\d{2})/, '$1 $2 $3');
        case 'SK':
            phoneNumber = phoneNumber.substr(0, 9);
            return phoneNumber.replace(/(\d{3})(\d{6})/, '$1-$2');
        case 'ZA':
            phoneNumber = phoneNumber.substr(0, 10);
            return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        case 'NL':
            return phoneNumber.substr(0, 9);
        case 'IE':
            phoneNumber = phoneNumber.substr(0, 10);
            return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
        case 'SG':
            phoneNumber = phoneNumber.substr(0, 8);
            return phoneNumber.replace(/(\d{4})(\d{4})/, '$1-$2');
        case 'PH':
            phoneNumber = phoneNumber.substr(0, 11);
            return phoneNumber.replace(/(\d{4})(\d{7})/, '$1-$2');
        case 'TH':
            phoneNumber = phoneNumber.substr(0, 9);
            return phoneNumber.replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3');
        case 'HK':
            phoneNumber = phoneNumber.substr(0, 8);
            return phoneNumber.replace(/(\d{4})(\d{4})/, '$1-$2');
        case 'MA':
            phoneNumber = phoneNumber.substr(0, 8);
            return phoneNumber.replace(/(\d{4})(\d{4})/, '$1-$2');
        case 'BN':
            phoneNumber = phoneNumber.substr(0, 7);
            return phoneNumber.replace(/(\d{3})(\d{4})/, '$1-$2');
        case 'VN':
            phoneNumber = phoneNumber.substr(0, 11);
            return phoneNumber.replace(/(\d{4})(\d{4})(\d{3})/, '$1 $2 $3');
        case 'MY':
            // MY phone numbers could be 10 or 11 digits long.
            phoneNumber = phoneNumber.substr(0, 11);
            if (phoneNumber.length == 10) {
                return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2 $3');
            } else if (phoneNumber.length == 11) {
                return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2 $3');
            } else {
                return phoneNumber;
            }
            break;
        case 'FI':
            // FI phone numbers could be 10 or 11 digits long.
            phoneNumber = phoneNumber.substr(0, 11);
            if (phoneNumber.length == 10) {
                return phoneNumber.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
            } else if (phoneNumber.length == 11) {
                return phoneNumber.replace(/(\d{4})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
            }
            break;
        case 'ID':
            // FI phone numbers could be 9 to 12 digits long.
            phoneNumber = phoneNumber.substr(0, 12);
            if (phoneNumber.length == 9) {
                return phoneNumber.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
            } else if (phoneNumber.length == 10) {
                return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
            } else if (phoneNumber.length == 11) {
                return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1 $2 $3');
            } else if (phoneNumber.length == 12) {
                return phoneNumber.replace(/(\d{4})(\d{4})(\d{4})/, '$1 $2 $3');
            } else {
                return phoneNumber;
            }
            break;
        case 'SE':
            // SE phone numbers could be 8 to 10 digits long.
            phoneNumber = phoneNumber.substr(0, 10);
            if (phoneNumber.length == 8) {
                return phoneNumber.replace(/(\d{4})(\d{2})(\d{2})/, '$1 $2 $3');
            } else if (phoneNumber.length == 9) {
                return phoneNumber.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
            } else if (phoneNumber.length == 10) {
                return phoneNumber.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
            }
            break;
        default:
            return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }
    };

    /* Get the format in which the phone number should be send to the service,
     or to be displayed in the input field. */
    var getPhoneSaveFormat = function(countryCode, phoneNumber) {
        if (!phoneNumber) {
            return;
        }
        phoneNumber = phoneNumber.replace(/\D/g, '');

        // countryCode represents the code selected for the phone number.
        // It may not be the same as the market.
        switch (countryCode) {
        case 'US':
            return phoneNumber.substr(0, 10);
        case 'CA':
            return phoneNumber.substr(0, 10);
        case 'AU':
            return phoneNumber.substr(0, 10);
        case 'NZ':
            return phoneNumber.substr(0, 10);
        case 'ES':
            return phoneNumber.substr(0, 9);
        case 'FR':
            return phoneNumber.substr(0, 11);
        case 'GB':
            return phoneNumber.substr(0, 11);
        case 'NO':
            return phoneNumber.substr(0, 11);
        case 'DE':
            return phoneNumber.substr(0, 11);
        case 'BE':
            return phoneNumber.substr(0, 10);
        case 'AT':
            return phoneNumber.substr(0, 10);
        case 'CZ':
            return phoneNumber.substr(0, 9);
        case 'DK':
            return phoneNumber.substr(0, 8);
        case 'HU':
            return phoneNumber.substr(0, 9);
        case 'IS':
            return phoneNumber.substr(0, 7);
        case 'IL':
            return phoneNumber.substr(0, 10);
        case 'IT':
            return phoneNumber.substr(0, 10);
        case 'LU':
            return phoneNumber.substr(0, 9);
        case 'PT':
            return phoneNumber.substr(0, 9);
        case 'RO':
            return phoneNumber.substr(0, 9);
        case 'RU':
            return phoneNumber.substr(0, 7);
        case 'SK':
            return phoneNumber.substr(0, 9);
        case 'ZA':
            return phoneNumber.substr(0, 10);
        case 'NL':
            return phoneNumber.substr(0, 9);
        case 'IE':
            return phoneNumber.substr(0, 10);
        case 'FI':
            return phoneNumber.substr(0, 11);
        case 'SE':
            return phoneNumber.substr(0, 10);
        case 'SG':
            return phoneNumber.substr(0, 8);
        case 'PH':
            return phoneNumber.substr(0, 11);
        case 'TH':
            return phoneNumber.substr(0, 9);
        case 'HK':
            return phoneNumber.substr(0, 8);
        case 'MA':
            return phoneNumber.substr(0, 8);
        case 'ID':
            return phoneNumber.substr(0, 12);
        case 'BN':
            return phoneNumber.substr(0, 7);
        case 'VN':
            return phoneNumber.substr(0, 11);
        case 'MY':
            return phoneNumber.substr(0, 11);
        default:
            return phoneNumber;
        }
    };

    return {
        'getPhoneDisplayFormat': getPhoneDisplayFormat,
        'getPhoneSaveFormat': getPhoneSaveFormat
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/phoneNumberFormatter.js
// module id = 359
// module chunks = 0